import type { EndpointSpec, Translate } from '../../../components/apidocs';

/** Balance API — ยอดคงเหลือ + สรุปเงินแช่แข็ง */
export const BALANCE_ENDPOINTS = (t: Translate): EndpointSpec[] => [
  {
    method: 'GET',
    path: '/wallet',
    description: t('apiDocs.getBalanceDesc'),
    response: {
      status: 200,
      id: 'balance-res',
      code: `{
  "success": true,
  "data": {
    "balance": 1234.56,
    "payout_balance": 500.00,
    "total_credit": 5000.00,
    "total_debit": 3765.44,
    "total_payout_credit": 1000.00,
    "total_payout_debit": 500.00,
    "updated_at": "2025-10-09T12:45:00.000Z",
    "freeze_summary": {
      "count": 2,
      "total_frozen": 800.00,
      "total_returned": 600.00,
      "total_deducted": 200.00,
      "items": [
        {
          "freeze_date": "2025-09-01",
          "status": "unfrozen",
          "total_frozen": 500.00,
          "returned_amount": 400.00,
          "deducted_amount": 100.00,
          "created_at": "2025-09-01T08:00:00.000Z"
        },
        {
          "freeze_date": "2025-10-01",
          "status": "frozen",
          "total_frozen": 300.00,
          "returned_amount": null,
          "deducted_amount": null,
          "created_at": "2025-10-01T08:00:00.000Z"
        }
      ]
    }
  }
}`,
    },
    responseFields: {
      rows: [
        { name: 'balance', type: 'number', description: t('apiDocs.fieldBalance') },
        { name: 'payout_balance', type: 'number', description: t('apiDocs.fieldPayoutBalance') },
        { name: 'total_credit', type: 'number', description: t('apiDocs.fieldTotalCredit') },
        { name: 'total_debit', type: 'number', description: t('apiDocs.fieldTotalDebit') },
        { name: 'total_payout_credit', type: 'number', description: t('apiDocs.fieldTotalPayoutCredit') },
        { name: 'total_payout_debit', type: 'number', description: t('apiDocs.fieldTotalPayoutDebit') },
        { name: 'updated_at', type: 'string', description: t('apiDocs.fieldUpdatedAt') },
        { name: 'freeze_summary', type: 'object', description: t('apiDocs.fieldFreezeSummary') },
        { name: 'freeze_summary.count', type: 'number', description: t('apiDocs.fieldFreezeCount') },
        { name: 'freeze_summary.total_frozen', type: 'number', description: t('apiDocs.fieldFreezeTotalFrozen') },
        { name: 'freeze_summary.total_returned', type: 'number', description: t('apiDocs.fieldFreezeTotalReturned') },
        { name: 'freeze_summary.total_deducted', type: 'number', description: t('apiDocs.fieldFreezeTotalDeducted') },
        { name: 'freeze_summary.items', type: 'array', description: t('apiDocs.fieldFreezeItems') },
        { name: 'items[].freeze_date', type: 'string', description: t('apiDocs.fieldFreezeDate') },
        { name: 'items[].status', type: 'string', description: t('apiDocs.fieldFreezeStatus') },
        { name: 'items[].total_frozen', type: 'number', description: t('apiDocs.fieldFreezeItemTotalFrozen') },
        { name: 'items[].returned_amount', type: 'number | null', description: t('apiDocs.fieldFreezeReturnedAmount') },
        { name: 'items[].deducted_amount', type: 'number | null', description: t('apiDocs.fieldFreezeDeductedAmount') },
      ],
    },
  },
];
